import { redeemYotpoCredits } from '../api/credits.api';

export const redeemYotpoCreditsSucceededEvent = redeemYotpoCredits.matchFulfilled;
